export const ALL_BUNDLES_LABEL = 'All Bundles'
